module.exports = __webpack_public_path__ + "assets/speaker.58ac5c00.svg";